<template>
  <v-container>
    <v-alert type="error" v-if="$store.state.error">{{
      $store.state.error
    }}</v-alert>
    <!--if not token is provided in the URL present the login page-->
    <Login v-if="!$store.state.token && !$store.state.error" />
    <Authenticate v-if="$store.state.token" />
    <LivePoll v-if="$store.state.user && $store.state.event" />
  </v-container>
</template>

<script>
// @ is an alias to /src
import Login from '@/components/Login';
import Authenticate from '@/components/Authenticate.vue';
import LivePoll from '@/components/LivePoll.vue';
//import VoteAtOnce from '@/components/VoteAtOnce.vue';

export default {
  name: 'Embed',
  components: {
    Authenticate,
    LivePoll,
    Login
  },
  mounted() {}
};
</script>
